import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { distribuidorModulo } from '../diccionarios/distribuidorModulo';
import { DistribuidorMantenedorModel } from '../models/distribuidorMantenedorModel';
import { DistribuidorModel } from '../models/distribuidorModel';
import { PresupuestoModel } from '../models/presupuestoModel';
import { RutaModel } from '../models/rutaModel';

@Injectable({
  providedIn: 'root'
})
export class DistribuidorService {


  diccionarioUrl: any;
  urlDistribuidor: string;
  constructor(
    private commom: CommonService,
    private utilServices: UtilsService
  ) {
    this.urlDistribuidor = this.utilServices.getDistribuidor();
    this.diccionarioUrl = distribuidorModulo.url;
  }

  getAllCliente(innIdDistribuidor: string): Observable<DistribuidorModel[]> {
    return this.commom.peticionGetConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.recepcionCliente + '/' + innIdDistribuidor);
  }

  postUploadFileCliente(innObjeto: FormData, innIdDistribuidor: string): Observable<DistribuidorModel[]> {
    return this.commom.peticionPostConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.recepcionCliente + '/' + innIdDistribuidor, innObjeto);
  }

  postSaveFileCliente(innListObjeto: DistribuidorModel[]) {
    return this.commom.peticionPostConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.recepcionClienteSave, innListObjeto);
  }

  deleteCliente(innObjeto: DistribuidorModel) {
    return this.commom.peticionDeleteConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.recepcionCliente + '/' + innObjeto.codigoDistribuidor);
  }

  getAllPresupuesto(innIdDistribuidor: string): Observable<PresupuestoModel[]> {
    return this.commom.peticionGetConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.recepcionPresupuesto + '/' + innIdDistribuidor);
  }

  postUploadFilePresupuesto(innObjeto: FormData, innIdDistribuidor: string): Observable<PresupuestoModel[]> {
    return this.commom.peticionPostConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.recepcionPresupuesto + '/' + innIdDistribuidor, innObjeto);
  }

  postSaveFilePresupuesto(innListObjeto: PresupuestoModel[]) {
    return this.commom.peticionPostConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.recepcionPresupuestoSave, innListObjeto);
  }

  deletePresupuesto(innObjeto: PresupuestoModel) {
    return this.commom.peticionDeleteConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.recepcionPresupuesto + '/' + innObjeto.clienteDistribuidor
      + '/' + innObjeto.anio + '/' + innObjeto.mes + '/' + innObjeto.item.trim() + '/' + innObjeto.contenedor);
  }

  getAllRuta(innIdDistribuidor: string): Observable<RutaModel[]> {
    return this.commom.peticionGetConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.recepcionRuta + '/' + innIdDistribuidor);
  }

  postUploadFileRuta(innObjeto: FormData, innIdDistribuidor: string): Observable<RutaModel[]> {
    return this.commom.peticionPostConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.recepcionRuta + '/' + innIdDistribuidor, innObjeto);
  }

  postSaveFileRuta(innListObjeto: RutaModel[]) {
    return this.commom.peticionPostConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.recepcionRutaSave, innListObjeto);
  }

  deleteRuta(innObjeto: RutaModel) {
    return this.commom.peticionDeleteConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.recepcionRuta + '/' + innObjeto.codigoClienteDistribuidor)
  }

  getVendedor() {
    return this.commom.peticionGetConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.vendedorLista);
  }

  downloadFile(innobj: any) {
    return this.commom.peticionPostConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.proveerCliente, innobj);
  }

  getDistribuidor() {
    // console.log(this.urlDistribuidor + this.diccionarioUrl.distribuidor.distribuidor);
    return this.commom.peticionGetConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.distribuidor);
  }

  postDistribuidor(innObjDistri: DistribuidorMantenedorModel) {
    //console.log(this.urlDistribuidor + this.diccionarioUrl.distribuidor.distribuidor);
    return this.commom.peticionPostConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.distribuidor, innObjDistri);
  }

  putDistribuidor(innObjDistri: DistribuidorMantenedorModel) {
    //console.log(this.urlDistribuidor + this.diccionarioUrl.distribuidor.distribuidor);
    return this.commom.peticionPutConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.distribuidor, innObjDistri);
  }

  deleteDistribuidor(idObjDistri: string) {
    //console.log(this.urlDistribuidor + this.diccionarioUrl.distribuidor.distribuidor);
    return this.commom.peticionDeleteConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.distribuidor + '/' + idObjDistri);
  }

  getReportDistribuidor(objDistribuidor: any) {
    //console.log(this.urlDistribuidor + this.diccionarioUrl.distribuidor.reporteDistribuidor);
    return this.commom.peticionPostConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.reporteDistribuidor, objDistribuidor);
  }

  getAllSellin(innIdDistribuidor: string): Observable<any[]> {
    return this.commom.peticionGetConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.recepcionSellin + '/' + innIdDistribuidor);
  }

  postUploadFileSellin(innObjeto: FormData, innIdDistribuidor: string): Observable<any[]> {
    return this.commom.peticionPostConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.recepcionSellin + '/' + innIdDistribuidor, innObjeto);
  }

  postSaveFileSellin(innListObjeto: any[]) {
    return this.commom.peticionPostConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.recepcionSellinSave, innListObjeto);
  }

  deleteSellin(innObjeto: any) {
    return this.commom.peticionDeleteConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.recepcionSellin + '/' + innObjeto.idDistribuidor + '/' + innObjeto.anio + '/' + innObjeto.mes + '/' + innObjeto.articulo + '/' + innObjeto.contenedor)
  }

  getPresupuestoSellIn(innObj: any) {
    return this.commom.peticionPostConHeader(this.urlDistribuidor + this.diccionarioUrl.distribuidor.reporteSellIn, innObj);
  }
}
